import React, { memo } from 'react';
import Modal from '../Modal';
import DoiSuccess from '../doiSuccess';
import ResetPasswordSuccess from '../resetPasswordSuccess';
import { OVERLAYS } from '../../types';

export const OVERLAY_MAP = {
    [OVERLAYS.OVERLAY_RESET_PASSWORD]: ResetPasswordSuccess,
    [OVERLAYS.OVERLAY_DOI]: DoiSuccess,
};

interface OverlayWrapperProps {
    closeOverlay?: () => void;
    successOverlay: OVERLAYS;
}
const SuccessOverlayWrapper = memo(
    ({ closeOverlay, successOverlay }: OverlayWrapperProps) => {
        const SuccessOverlayComponent = OVERLAY_MAP[successOverlay];

        return (
            <Modal visible={!!SuccessOverlayComponent} onClose={closeOverlay}>
                {SuccessOverlayComponent && (
                    <SuccessOverlayComponent onClose={closeOverlay} />
                )}
            </Modal>
        );
    },
);

export default SuccessOverlayWrapper;
